import type { IntersectionDefinition } from '../types/intersection';
import type { GroupBearingOverride } from './overridesRuntime';

/**
 * Aplica correcciones de rotación (`bearing`, 0-359°) sobre grupos concretos
 * del dataset generado — mismo patrón que `applyPositionOverrides.ts`, pero
 * sin tocar `position`: el `groupId` solo es único dentro de su regulador,
 * así que la clave del override es compuesta (`cabinetId-groupId`).
 */
export function applyGroupBearingOverrides(
  base: IntersectionDefinition[],
  overrides: GroupBearingOverride[],
): IntersectionDefinition[] {
  if (overrides.length === 0) return base;
  const byKey = new Map(overrides.map(o => [`${o.cabinetId}-${o.groupId}`, o]));
  const cabinetIds = new Set(overrides.map(o => o.cabinetId));

  return base.map((ix) => {
    if (!cabinetIds.has(ix.cabinet.logicalId)) return ix;
    return {
      ...ix,
      groups: ix.groups.map((g) => {
        const override = byKey.get(`${ix.cabinet.logicalId}-${g.id}`);
        return override ? { ...g, bearing: override.bearing } : g;
      }),
    };
  });
}
